var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5047 20.2404L19.3197 23.9325C20.0696 24.4055 20.9926 23.7017 20.7734 22.8364L19.0889 16.2138C19.0434 16.0302 19.0506 15.8375 19.1098 15.6579C19.169 15.4783 19.2778 15.319 19.4235 15.1985L24.6385 10.8488C25.3192 10.2835 24.9731 9.14125 24.0847 9.08356L17.2775 8.64513C17.0918 8.63432 16.9132 8.56965 16.7636 8.459C16.6141 8.34836 16.5 8.19654 16.4353 8.0221L13.897 1.63027C13.8298 1.44556 13.7074 1.28599 13.5464 1.17324C13.3854 1.06048 13.1936 1 12.9971 1C12.8005 1 12.6087 1.06048 12.4477 1.17324C12.2867 1.28599 12.1643 1.44556 12.0971 1.63027L9.55886 8.0221C9.49417 8.19654 9.38007 8.34836 9.2305 8.459C9.08092 8.56965 8.90236 8.63432 8.71662 8.64513L1.90944 9.08356C1.02104 9.14125 0.674914 10.2835 1.35563 10.8488L6.57063 15.1985C6.71639 15.319 6.82513 15.4783 6.88433 15.6579C6.94352 15.8375 6.95077 16.0302 6.90522 16.2138L5.34764 22.3518C5.08228 23.3902 6.18989 24.2324 7.07828 23.6671L12.4894 20.2404C12.6412 20.1439 12.8173 20.0927 12.9971 20.0927C13.1769 20.0927 13.353 20.1439 13.5047 20.2404Z",
    fill: "#F8D57E",
    stroke: "#F8D57E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4219173ab7e7548789b442981901b1bb.svg";
export { ForwardRef as ReactComponent };